// eslint-disable-next-line import/prefer-default-export
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const UPDATE_DELIVERY_METHOD = 'UPDATE_DELIVERY_METHOD';
export const OPEN_DELIVERY_MODAL = 'OPEN_DELIVERY_MODAL';
export const SET_USER_ADDRESS = 'SET_USER_ADDRESS';

